import { Optional } from '@lib/interfaces/common.interface';
import { SortDirection } from '@lib/modules/table/components';

export enum UserTitle {
    MR = 'MR',
    MRS = 'MRS',
    MISS = 'MISS',
}

export enum Gender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export enum EmploymentType {
    SALARIED = 'SALARIED',
    SELF_EMPLOYED = 'SELF_EMPLOYED',
    RETIRED = 'RETIRED',
    NOT_EMPLOYED = 'NOT_EMPLOYED',
    BUSINESS_OWNER = 'BUSINESS_OWNER',
    STUDENT = 'STUDENT',
    HOMEMAKER = 'HOMEMAKER',
    OTHER = 'OTHER',
}

export enum IndustryType {
    I01 = 'I01',
    I02 = 'I02',
    I03 = 'I03',
    I04 = 'I04',
    I05 = 'I05',
    I06 = 'I06',
    I07 = 'I07',
    I08 = 'I08',
    I09 = 'I09',
    I11 = 'I11',
    I12 = 'I12',
    I13 = 'I13',
    I14 = 'I14',
    I15 = 'I15',
    I16 = 'I16',
    I17 = 'I17',
    I18 = 'I18',
    I19 = 'I19',
    I20 = 'I20',
    I21 = 'I21',
    I22 = 'I22',
    I23 = 'I23',
    I24 = 'I24',
    I25 = 'I25',
    I26 = 'I26',
    I27 = 'I27',
    I28 = 'I28',
    I29 = 'I29',
    I30 = 'I30',
    I00 = 'I00',
}

export enum RelationshipWithParent {
    SON = 'SON',
    DAUGHTER = 'DAUGHTER',
    NEPHEW = 'NEPHEW',
    NIECE = 'NIECE',
    HUSBAND = 'HUSBAND',
    WIFE = 'WIFE',
    FATHER = 'FATHER',
    MOTHER = 'MOTHER',
    EMPLOYEE = 'EMPLOYEE',
    OTHER = 'OTHER',
}

export enum UserType {
    INDIVIDUAL = 'INDIVIDUAL',
    BUSINESS = 'BUSINESS',
    DIRECTOR = 'DIRECTOR',
    SIGNATURE = 'SIGNATURE',
    SHAREHOLDER = 'SHAREHOLDER',
    SHAREHOLDER_BUSINESS = 'SHAREHOLDER_BUSINESS',
    AGENT = 'AGENT',
    CUSTOMER = 'CUSTOMER',
}

export enum UserStatus {
    PENDINGKYC = 'PENDINGKYC',
    PENDINGKYB = 'PENDINGKYB',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
    PENDINGIDVERIFICATION = 'PENDINGIDVERIFICATION',
    INITIATED = 'Initiated',
    PENDING = 'Pending',
    APPROVED = 'Approved',
    RETURNED = 'Returned',
    REJECTED = 'Rejected',
    EXECUTED = 'Executed',
    FAILED = 'Failed',
    CREATED = 'CREATED',
    COMPLETED = 'COMPLETED',
}

export enum RiyadUserStatus {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
}

export enum UserStatusReason {
    I0 = 'I0',
    A0 = 'A0',
    A1 = 'A1',
    A1I = 'A1I',
    A1R = 'A1R',
    A2 = 'A2',
    A3 = 'A3',
    A4 = 'A4',
    A5 = 'A5',
    A6 = 'A6',
    A7 = 'A7',
    A8 = 'A8',
    A10 = 'A10',
    B0 = 'B0',
    B1 = 'B1',
    B2 = 'B2',
    B3 = 'B3',
    B4 = 'B4',
    B5 = 'B5',
    B6 = 'B6',
    B7 = 'B7',
    B8 = 'B8',
    B9 = 'B9',
    B10 = 'B10',
    B11 = 'B11',
    B2E = 'B2E',
    B0E = 'B0E',
    B9E = 'B9E',
    B10E = 'B10E',
    B11E = 'B11E',
    B12 = 'B12',
    B19 = 'B19',
    B20 = 'B20',
    B21 = 'B21',
    B22 = 'B22',
    S0 = 'S0',
    S1 = 'S1',
    S2 = 'S2',
    S3 = 'S3',
    S4 = 'S4',
    S5 = 'S5',
    S6 = 'S6',
    S7 = 'S7',
    S9 = 'S9',
    S10 = 'S10',
    T0 = 'T0',
    T1 = 'T1',
    T2 = 'T2',
    T3 = 'T3',
    T4 = 'T4',
    T5 = 'T5',
    T6 = 'T6',
    T7 = 'T7',
    T8 = 'T8',
    T9 = 'T9',
    T10 = 'T10',
    T11 = 'T11',
    T12 = 'T12',
    T13 = 'T13',
    T12E = 'T12E',
    T13E = 'T13E',
    O1 = 'O1',
}

export enum SupportedKycPolicies {
    UAE_INDIVIDUAL_PRIMARY = 'UAE_INDIVIDUAL_PRIMARY',
    UAE_INDIVIDUAL_SECONDARY = 'UAE_INDIVIDUAL_SECONDARY',
}

export interface IKycReport {
    id: string;
    user_id: string;
    case_id: string;
    note: string;
    status: string;
    status_reason: string;
    status_reason_code: string;
    created: string;
    case_creation: string;
    entity_type: string;
    modified: string;
}

export interface IKycReportListing {
    data: IKycReport[];
}

export enum IncorporationType {
    LTD = 'LTD',
    LLC = 'LLC',
    FZE = 'FZE',
    FZCO = 'FZCO',
    FZ_LLC = 'FZ-LLC',
    INC = 'INC',
    FOUNDATION = 'FOUNDATION',
    TRUST = 'TRUST',
    FUND = 'FUND',
    PUBLIC_TRADED = 'PUBLIC_TRADED',
    GOVT_OWNED = 'GOVT_OWNED',
    LLP = 'LLP',
    OTHER = 'OTHER',
}

export enum IdentificationType {
    PASSPORT = 'PASSPORT',
    VISA = 'VISA',
    NATIONAL_ID = 'NATIONAL_ID',
    TRADE_LICENSE = 'TRADE_LICENSE',
    COMMERCIAL_LICENSE = 'COMMERCIAL_LICENSE',
    INCORPORATION_CERT = 'INCORPORATION_CERT',
    INCUMBENCY_CERT = 'INCUMBENCY_CERT',
    MEMORANDUM_ARTICLES = 'MEMORANDUM_ARTICLES',
    BANK_STATEMENT = 'BANK_STATEMENT',
    ADDITIONAL = 'ADDITIONAL',
}

export enum IdentificationDocumentType {
    NATIONAL_ID_FRONT = 'NATIONAL_ID_FRONT',
    NATIONAL_ID_BACK = 'NATIONAL_ID_BACK',
    PASSPORT_PAGE1 = 'PASSPORT_PAGE1',
    PASSPORT_PAGE2 = 'PASSPORT_PAGE2',
    VISA = 'VISA',
    ADDITIONAL_PAGE_1 = 'ADDITIONAL_PAGE_1',
    ADDITIONAL_PAGE_2 = 'ADDITIONAL_PAGE_2',
    ADDITIONAL_PAGE_3 = 'ADDITIONAL_PAGE_3',
    ADDITIONAL_PAGE_4 = 'ADDITIONAL_PAGE_4',
}

export enum IdentificationStatus {
    PENDINGKYB = 'PENDINGKYB',
}

export enum IdentificationStatusReasonCode {
    I0 = 'I0',
}

export interface ICustomer {
    id: string;
    user_id: string;
    title: UserTitle;
    first_name: string;
    middle_name: string;
    last_name: string;
    native_name: string;
    full_legal_name: string;
    full_name_local_language: string;
    mother_name: string;
    father_name: string;
    date_of_birth: string;
    email: string;
    mobile: string;
    address: IAddress;
    gender: Gender;
    preferred_language: string;
    place_of_birth: string;
    place_of_birth_city: string;
    nationality: string;
    parent_user_id: string;
    created: string;
    modified: string;
    country_residence: string;
    country_tax_residence: string;
    education_level: string;
    employment_type: EmploymentType;
    employment_title: string;
    monthly_salary: number;
    company_name: string;
    company_address: IAddress;
    company_country: string;
    industry_type: IndustryType;
    expected_monthly_balance: number;
    relationship_with_parent: RelationshipWithParent;
    user_type: UserType;
    business_legal_name: string;
    business_dba_name: string;
    date_established: string;
    phone_number: string;
    website: string;
    status: UserStatus;
    status_reason_code: UserStatusReason;
    kyc_policy_passed: SupportedKycPolicies;
    designation: string;
    shares_percentage: number;
    share_controller_name: string;
    local_address: IAddress;
    incorporation_type: IncorporationType;
    entity_registered_no: string;
    old_entity_name: string;
    old_entity_ops_start_date: string;
    old_entity_ops_end_date: string;
    regulated_entity: boolean;
    regulator_name: string;
    business_activities: string;
    other_operated_countries: string;
    tax_residence_country: string;
    tin: string;
    external_auditor_name: string;
    director_list: Array<string>;
    signature_list: Array<string>;
    shareholder_list: Array<string>;
    company_onbehalf: boolean;
    company_onbehalf_relation: string;
    group_additional_info: ICustomerGroupAdditionalInfo;
    pep_check_info: Optional<IUserPepCheckInfo>;
    no_of_employees: number;
    accept_cash_check: boolean;
    annual_turnover: number;
    source_of_funds: string;
    source_fund_uae: boolean;
    due_diligence_declaration: IUserDueDiligenceDeclaration;
    license_type: string;
    license_expiry: string;
    currency: string;
    modified_by: string;
    custom_info: Optional<{
        custom: string;
        building: string;
        is_passport_uploaded: string;
        user_external_created: string;
        user_external_validated: string;
        registerinformation_expirydate: string;
        passport_mother_full_name_ocr: string;
        national_id_uploaded: string;
        registerinformation_number: string;
        national_mother_last_name_ocr: string;
        passport_last_name_ocr: string;
        registerinformation_legalid: string;
        registerinformation_issuancedate: string;
        national_third_name_latin_ocr: string;
        national_last_name_latin_ocr: string;
        national_id_uploaded_result_clear: string;
        national_mother_first_name_latin_ocr: string;
        passport_uploaded_result_clear: string;
        national_mother_first_name_ocr: string;
        residency_card_uploaded: string;
        national_second_name_ocr: string;
        passport_place_of_birth: string;
        national_third_name_ocr: string;
        registerinformation_national_id: string;
        national_second_name_latin_ocr: string;
        national_first_name_latin_ocr: string;
        national_mrz_line_3: string;
        national_mrz_line_2: string;
        national_last_name_ocr: string;
        date_of_birth: string;
        place_of_birth_city: string;
        national_first_name_ocr: string;
        national_mrz_line_1: string;
        national_family_number_latin_ocr: string;
        passport_uploaded: string;
        passport_mrz_line_2: string;
        national_mother_last_name_latin_ocr: string;
        passport_mrz_line_1: string;
        passport_first_name_ocr: string;
        passport_national_number: string;
        passport_document_number: string;
        passport_issuance_country: string;
        passport_issuance_date: string;
        passport_mother_name: string;
        passport_issuing_authority: string;
        passport_expiry_date: string;
        passport_full_name: string;
        passport_date_of_birth: string;
        registerinformation_city_description: string;
        registerinformation_region_description: string;
        user_placeofbirth_description: string;
        spouse1_first_name: string;
        spouse1_family_name: string;
        mother_family_name: string;
        kfs: string;
        [key: string]: string | undefined;
        card_id: string;
    }>;
    location?: ILocation;
    result_code?: string;
    description?: string;
    iban?: string;
}

export interface IAddress {
    address_line1: string;
    address_line2: string;
    building?: string;
    city: string;
    district?: string;
    state: string;
    street?: string;
    postal_code: string;
    country: string;
    nearest_place?: string;
}

export interface IInternationalTransactionParam {
    internationalTransaction: boolean;
}
export interface ICustomerStatusPopup {
    id: string;
    user_status: string;
    status: UserStatus;
    first_name: string;
    middle_name: string;
    last_name: string;
    native_name: string;
    full_legal_name: string;
    nationality?: string;
    created: string;
    change_status_value?: string;
    status_reason_code?: string;
    custom_info?: Optional<{
        custom: string;
        national_id_uploaded: string;
        passport_uploaded: string;
        residency_card_uploaded?: string;
        visa_or_iqama_uploaded?: string;
        user_external_validated: string;
        is_passport_uploaded: string;
    }>;
    hasKYCReport?: boolean;
}

export interface ICustomerGroupAdditionalInfo {
    group_entity: Optional<boolean>;
    independent_entity: Optional<boolean>;
    special_investment: Optional<boolean>;
    entity_details: Optional<string>;
}

export interface IUserPepCheckInfo {
    pri_pep_check: Optional<boolean>;
    pri_pep_check_name: Optional<string>;
    sec_pep_check: Optional<boolean>;
    sec_pep_check_name: Optional<string>;
}

export interface IUserDueDiligenceDeclaration {
    bankruptcy_declaration: Optional<boolean>;
    disciplinary_declaration: Optional<boolean>;
    fraud_aml_declaration: Optional<boolean>;
    disqualification_declaration: Optional<boolean>;
    conviction_accusition_declaration: Optional<boolean>;
    breach_of_law_declaration: Optional<boolean>;
}

export interface ICustomerIdentification {
    id: string;
    type: IdentificationType;
    title: string;
    user_id: string;
    number: string;
    issuance_authority: string;
    place_of_issuance: string;
    issuance_date: string;
    expiration_date: string;
    document_status: IdentificationStatus;
    document_status_reason: IdentificationStatusReasonCode;
    files: Array<ICustomerIdentificationFile>;
    created: string;
    modified: string;
    identification_note: string;
}

export interface ICustomerAnalyticsData {
    percentage: number;
    direction: 'up' | 'down';
}

export interface ICustomerIdentificationFile {
    id: string;
    file_name: string;
    content_type: string;
    size: number;
    identification_type: IdentificationType;
    identification_document_type: IdentificationDocumentType;
    version: number;
    created: string;
    title: string;
}

export interface ICustomerIdentificationFlattenedFile extends ICustomerIdentificationFile {
    identification: ICustomerIdentification;
}

export interface ICustomerIdentificationFileWithMetadata extends ICustomerIdentificationFlattenedFile {
    file: Blob;
    fileBase64?: string;
}

export interface ICustomerAnalyticsApiResponse {
    account: ICustomerAnalyticsData;
    cards: ICustomerAnalyticsData;
    user: ICustomerAnalyticsData;
}

export interface IChangeCustomerStatusApiRequest {
    status: UserStatus;
    status_reason_code: UserStatusReason;
    reupload_passport?: boolean;
    reuplad_national_id?: boolean;
    reupload_residency_card?: boolean;
    reupload_visa_or_iqama?: boolean;
    modified_by?: string | null;
    note?: string;
}

export interface ICustomerCountApiResponse {
    total_customers: string;
    total_cards: string;
    total_accounts: string;
    details: ICustomerCountDetails;
}

export interface ICustomerCountDetails {
    customer_data: ICustomerCountData[];
    card_data: ICustomerCountCardData[];
    account_data: ICustomerCountAccountData[];
}

export interface ICustomerCountData {
    value: string;
    active: {
        count: number;
    };
    suspended: {
        count: number;
    };
    terminated: {
        count: number;
    };
    pending_kyc: {
        count: number;
    };
    pending_idv: {
        count: number;
    };
    new: {
        count: number;
    };
}

export interface ICustomerCountCardData {
    value: string;
    active: {
        count: number;
    };
    suspended: {
        count: number;
    };
    terminated: {
        count: number;
    };
    inactive?: {
        count: number;
    };
    prepaid?: {
        count: number;
    };
    credit?: {
        count: number;
    };
    cycle?: string;
    data?: {
        date: string;
        count: number;
    }[];
}

export interface ICustomerCountAccountData {
    value: string;
    active: {
        count: number;
    };
    suspended: {
        count: number;
    };
    terminated: {
        count: number;
    };
    cycle?: string;
    data?: {
        date: string;
        count: number;
    }[];
}

export interface ICustomerSearchRequest {
    ids?: Array<string>;
    id: string;
    name: string;
    alias: string;
    mobile: string;
    mobileNumber: string;
    pan: string;
    email: string;
    status: Array<UserStatus>;
    status_reason_code: Array<UserStatusReason>;
    user_type: UserType;
    business_legal_name: string;
    business_dba_name: string;
    website: string;
    created_from: string;
    created_to: string;
    modified_from: string;
    modified_to: string;
    bin: string;
    last_four: string;
    limit: number;
    after: string;
    sort_by: string;
    order_by: SortDirection;
    modalTitle?: string;
}

export interface ICreateCustomer {
    id: string;
    nationality: string;
    date_of_birth: string;
    first_name: string;
    last_name: string;
    mother_name: string;
    marital_status: string;
    gender: string;
    email: string;
    education_level: string;
    employment_type: string;
    preferred_language: string;
    full_name_local_language: string;
    mobile: string;
    address: IAddress;
    custom_info: Record<string, any>;
    location?: ILocation;
}

export interface ILocation {
    lat: string | number;
    lon: string | number;
}

export interface IIdentificationDocument {
    id?: string;
    type: IdentificationType;
    title?: string;
    number: string;
    issuance_authority?: string;
    place_of_issuance?: string;
    expiration_date?: string;
    issuance_date?: string;
    identification_note?: string;
}

export interface sdkToken {
    applicantId: string;
    token: string;
}

export interface IInternationalFlag {
    allow: boolean;
}

export interface customerSeflieVideoData {
    file: string;
    contentType: string;
    createdAt: string;
}
export interface IMobileHistory {
    id: string;
    user_id: string;
    old_mobile_number: string;
    new_mobile_number: string;
    source: string;
    status: string;
    created: string;
    modified?: string;
    attempt_count: number;
    email: string;
}

export interface IActivityLogMetadata {
    // Common fields
    note?: string;
    status?: string;
    currency?: string;
    amount?: string;

    // User / Agent / Card Status Changes
    old_status: string;
    new_status: string;
    old_status_reason_code: string;
    new_status_reason_code: string;

    // International Transaction Enablement
    allow?: string; // "true" | "false"

    // Agent Creation
    first_name?: string;
    last_name?: string;
    email?: string;
    mobile?: string;
    'location.lat'?: string;
    'location.lon'?: string;

    // Load / Unload Funds
    account_id?: string;
    transaction_id?: string;
    fee_amount?: string;
    permission?: string;
    userId?: string;
    workflowId?: string;

    // Other potential generic metadata
    reason?: string;
    statusReasonCode?: string;
    old_status_code?: string;
    new_status_code?: string;

    // Fallback — in case of unstructured metadata
    [key: string]: any;
}

export interface IActivityLog {
    id: string;
    action: string;
    subject: {
        user_id: string;
        user_phone: string;
    };
    action_taker: {
        admin_id: string;
        admin_name: string;
    };
    body: string;
    request_body?: string;
    metadata: IActivityLogMetadata;
    created: string;
    modified: string;
}

export interface IActivityLogFilter {
    action: string;
    subject: {
        user_id: string;
        user_phone: string;
    };
    action_taker: {
        admin_id: string;
        admin_name: string;
    };
    created: string;
    modified: string;
    limit?: number;
    after?: string;
    sort_by?: string;
    order_by?: SortDirection;
    actions?: string[];
}

export interface IActivityLogAdvanceSearch {
    user_id: string;
    user_phone: string;
    admin_name: string;
    actions?: string[];
}

export enum ActivityActionType {
    USER_STATUS_CHANGE = 'USER_STATUS_CHANGE',
    INTERNATIONAL_TRANSACTIONS_CHANGE = 'INTERNATIONAL_TRANSACTIONS_CHANGE',
    PASSPORT_APPROVED = 'PASSPORT_APPROVED',
    PASSPORT_REJECTED = 'PASSPORT_REJECTED',
    CARD_STATUS_CHANGE = 'CARD_STATUS_CHANGE',
    AGENT_STATUS_CHANGE_APPROVED = 'AGENT_STATUS_CHANGE_APPROVED',
    AGENT_STATUS_CHANGE_REJECTED = 'AGENT_STATUS_CHANGE_REJECTED',
    AGENT_STATUS_CHANGE_SUBMITTED = 'AGENT_STATUS_CHANGE_SUBMITTED',
    AGENT_CREATE = 'AGENT_CREATE',
    CARD_CREATE = 'CARD_CREATE',
    LOAD_FUNDS_SUBMITTED = 'LOAD_FUNDS_SUBMITTED',
    LOAD_FUNDS_APPROVED = 'LOAD_FUNDS_APPROVED',
    LOAD_FUNDS_REJECTED = 'LOAD_FUNDS_REJECTED',
    UNLOAD_FUNDS = 'UNLOAD_FUNDS',
}
